.banner-wrapper {
  strong,
  p {
    all: revert;
  }
}
